module.exports = __webpack_public_path__ + "img/img-info-img-s1.94399062.jpg";